jQuery(document).ready(function () {
    toggleFaq();
    topScrollUp();
    initMap();
    navigator();
});

function topScrollUp() {
    const toTopBtn = ['<a href="#top" class="scroll-top-btn"></a>'].join("");
    $("body").append(toTopBtn)
    $(".scroll-top-btn").hide();
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                $('.scroll-top-btn').fadeIn();
            } else {
                $('.scroll-top-btn').fadeOut();
            }
        });

        $('.scroll-top-btn').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });
}

function toggleFaq() {
    const faqParent = $('.individual__Faq');
    const faQuestion = $('.individual__Faq .faq__text');
    const faqContent = $('.faq__content');

    $(faqParent).each(function () {
        $(this).addClass('close');
        $(this).find(faqContent).hide();
    });

    $(faQuestion).click(function () {
        let faqClass = $(this).closest(faqParent).attr('class');
        if (faqClass.indexOf('close') !== -1) {
            $(faqParent).find(faqContent).slideUp('slow');
            $(faqParent).addClass('close').removeClass('open');
            $(this).closest(faqParent).removeClass('close');
            $(this).closest(faqParent).addClass('open');
            $(this).closest(faqParent).find(faqContent).slideDown('slow');
        } else {
            $(this).closest(faqParent).addClass('close');
            $(this).closest(faqParent).removeClass('open');
            $(this).closest(faqParent).find(faqContent).slideUp('slow');
        }
    });
}

function initMap() {
    jQuery('#accept-dsgvo').on('click', function () {
        jQuery('.hide-on-accept').css('display', 'none');
        jQuery('.map-widget').css('background-image', 'unset');
        let loc = "https://maps.google.com/maps?q=P%C3%B6hling%20GmbH%20%20Ostmilter%20Stra%C3%9Fe%2018%20%2048231%20Warendorf&t=&z=15&ie=UTF8&iwloc=&output=embed";
        jQuery('#map-location').css({"display": "block", "width": "100%", "height": "400px"});
        document.getElementById('map-location').setAttribute('src', loc);
    });
}

function navigator() {
    const togglerM = $('.menu__toggler__2');
    const menu = $('.menu__2');
    menu.hide();
    togglerM.on('click', () => {
        menu.fadeToggle().toggleClass('active');
        togglerM.toggleClass('active');
    })
}
